<template>
  <v-dialog v-model="value" persistent max-width="50rem">
    <v-card>
      <v-toolbar color="primary darken-1" dark dense>
        {{
          this.isEdit
            ? $t("portfolio.Achievement.editAchievement")
            : $t("portfolio.Achievement.addAchievement")
        }}
        <v-spacer></v-spacer>

        <v-btn icon dark @click="value = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="achievementForm" v-model="formValid">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-text-field
                  dense
                  :rules="[
                    value =>
                      value.length >= 3 || $t('portfolio.Achievement.validation.titleMinLength'),
                    value =>
                      value.length < 450 || $t('portfolio.Achievement.validation.titleMaxLength')
                  ]"
                  v-model="achievement.title"
                  :label="$tc('portfolio.Achievement.title')"
                  :placeholder="$t('portfolio.Achievement.title')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-textarea
                  dense
                  rows="3"
                  v-model="achievement.description"
                  :label="$tc('portfolio.Achievement.description')"
                  :placeholder="$t('portfolio.Achievement.description')"
                  outlined
                ></v-textarea>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      dense
                      v-model="achievement.achievementDate"
                      :rules="[value => !!value || $t('portfolio.Achievement.validation.required')]"
                      :label="$tc('portfolio.Achievement.date')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="achievement.achievementDate"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
                <v-col cols="12" class="pa-0">
                <custom-file-uploader
                  v-if="value"
                  ref="uploader"
                  @file-uploaded="onUploaded"
                  locationName="Portfolio"
                ></custom-file-uploader>
              </v-col>
            </v-row>
          
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :disabled="!formValid" @click="submitAchievement">{{
            $t("save")
          }}</v-btn>
          <v-btn text color="red" @click="value = false">{{ $t("cancel") }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import customFileUploader from "../../custom-file-uploader.vue";

export default {
  components: {
    customFileUploader
  },
  data() {
    return {
      isEdit: false,
      formValid: false,
      value: false,
      menu: false,
      achievement: {
        title: "",
        description: "",
        achievementDate: "",
        files: []
      }
    };
  },
  computed: {
    ...mapState(["UploaderUrl"])
  },
  methods: {
    submitAchievement() {
      this.$refs.achievementForm.validate();
      if (!this.formValid) {
        return;
      }
      if (this.isEdit) {
        this.axios
          .post("/Achievement/Update", this.achievement)
          .then(() => {
            this.$emit("success");
          })
          .catch(error => {
            console.error("Error updating achievement:", error);
          });
      } else {
        this.axios
          .post("/Achievement/Create", this.achievement)
          .then(() => {
            this.$emit("success");
          })
          .catch(error => {
            console.error("Error adding achievement:", error);
          });
      }
      this.value = false;
    },
    clear() {
      this.achievement = {
        title: "",
        description: "",
        achievementDate: "",
        files: []
      };
    },
    showDialog() {
      this.clear();
      this.isEdit = false;
      this.value = true;
      this.$refs.achievementForm.resetValidation();
    },
    showDialogEdit(achievement) {
      this.clear();
      this.isEdit = true;
      this.achievement = achievement;
      this.achievement.achievementDate = this.$moment(achievement.achievementDate).format(
        "YYYY-MM-DD"
      );

      this.value = true;
    },
    onUploaded(e) {
      const fileRes = JSON.parse(e.request.responseText).data;
      this.achievement.files.push({ fileUrl: fileRes.fileUrl });
    }
  }
};
</script>
